import { Trans } from 'react-i18next'

import { t } from 'i18next'

const PixSection = () => (
  <ul>
    <li>
      <Trans
        // @ts-expect-error: `i18nKey` is not recognized by the `Trans` component
        i18nKey="rm:pixInfo.clickRechargeButton"
        defaults='Após clicar no botão "<strong>Fazer recarga</strong>", o código <strong>PIX</strong> estará disponível para você efetuar o pagamento em <strong>até 1 hora</strong>.'
        components={{ strong: <strong /> }}
      />
    </li>
    <li>{t('rm:pixInfo.instantPaymentIdentification')}</li>
    <li>{t('rm:pixInfo.paymentNotMade')}</li>
    <li>
      <Trans
        // @ts-expect-error: `i18nKey` is not recognized by the `Trans` component
        i18nKey="rm:pixInfo.cannotChangeAmount"
        defaults="É importante lembrar que, após a finalização, não será possível alterar o valor dessa recarga. Portanto, <strong>tenha certeza do valor que deseja adicionar</strong>."
        components={{ strong: <strong /> }}
      />
    </li>
  </ul>
)

export default PixSection
